import { selectCurrentPresetValue } from '@epicuro-next/state/user-ui-state';
import { createSelector } from '@ngrx/store';
import {
  CheckOrderResult,
  Severity,
  ValidationResult,
} from 'graphql-api/baskets-api-interfaces';

import {
  selectAllowedMixedBasketRule,
  selectPoNumberRequiredRule,
} from './basket-configuration-rules.selectors';
import {
  selectCustomOrderReferenceNumber,
  selectIsBasketMixed,
} from './basket-data.selectors';

export const selectMixedBasketValidationResult = createSelector(
  selectAllowedMixedBasketRule,
  selectIsBasketMixed,
  selectCurrentPresetValue,
  (allowedMixedBasket, isMixedBasket, preset) => {
    const validationResults: ValidationResult[] = [];

    if (!allowedMixedBasket && isMixedBasket) {
      validationResults.push({
        severity: Severity.Error,
        message: $localize`:Cbasket|mixed basket validation@@validation_Mixed_Basket:Your current basket has products with different order type than the selected order type ${preset}`,
      });
    }

    return validationResults;
  },
);

export const selectPoNumberValidationResult = createSelector(
  selectCustomOrderReferenceNumber,
  selectPoNumberRequiredRule,
  (clientReferenceNumber, isPoNumberRequired) => {
    const validationResults: ValidationResult[] = [];

    if (isPoNumberRequired && !clientReferenceNumber) {
      validationResults.push({
        severity: Severity.Error,
        message: $localize`:Cbasket|po number validation@@Validation_Order_PoNumberRequired:Custom order reference number is required`,
      });
    }

    return validationResults;
  },
);

export const selectUIValidations = createSelector(
  selectMixedBasketValidationResult,
  selectPoNumberValidationResult,
  (
    mixedBasketValidations,
    poNumberRequiredValidations,
  ): CheckOrderResult | null => {
    const validationResults = [
      ...mixedBasketValidations,
      ...poNumberRequiredValidations,
    ];

    return validationResults.length ? { validationResults } : null;
  },
);
